module.exports = __webpack_public_path__ + "img/[足球].005a81b7.svg";